import { useEffect, useState } from 'react';
import axiosInstance, { useAuth } from '../AuthContext';

export function useAuthenticatedImage(documentId) {
    const { accessToken } = useAuth();
    const [src, setSrc] = useState(null);

    useEffect(() => {
        if (!documentId || !accessToken) {
            setSrc(null);
            return;
        }

        let objectUrl = null;
        let cancelled = false;

        axiosInstance
            .get(`/documents/${documentId}/thumbnail/`, {
                responseType: 'blob',
            })
            .then((res) => {
                if (cancelled) return;
                objectUrl = URL.createObjectURL(res.data);
                setSrc(objectUrl);
            })
            .catch(() => {
                if (!cancelled) setSrc(null);
            });

        return () => {
            cancelled = true;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [documentId, accessToken]);

    return src;
}

export { useAuthenticatedImage as AuthenticatedImage };
